import { Box, SxProps } from '@mui/material';
import { MouseEvent } from 'react';

export const XsTag = ({
  label,
  sx,
  onClick,
}: {
  label: string;
  sx?: SxProps;
  onClick?: (e: MouseEvent) => void;
}) => {
  return (
    <Box
      sx={{
        fontSize: '10px',
        color: 'text.primary',
        backgroundColor: 'background.default',
        borderRadius: 1,
        height: '18px',
        display: 'flex',
        px: 1,
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
      onClick={onClick}
    >
      {label}
    </Box>
  );
};
